var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"line","height":"350","options":_vm.lineAreaChartSpline.chartOptions,"series":_vm.lineAreaChartSpline.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }